import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"scrollable":"","persistent":""},model:{value:(_vm.modalStatus),callback:function ($$v) {_vm.modalStatus=$$v},expression:"modalStatus"}},[_c(VCard,[_c(VCardText,[_c('iframe',{staticStyle:{"height":"90vh"},attrs:{"src":_vm.url,"width":"100%"}})]),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"color":"red","dark":""},on:{"click":_vm.closeModal}},[_vm._v("Cerrar")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }